<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('dimensions') }}
                <v-spacer></v-spacer>
                <!-- <v-btn
                    class="mx-1"

                    icon>
                    <v-icon>mdi-eye</v-icon>
                </v-btn> -->
                <v-btn
                    class="mx-1"
                    @click="createDataFetch"
                    icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        :label="$t('search')"
                        solo
                        v-model="search"
                        hide-details>
                    </v-text-field>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            @click="openDimensionDialog({editMode: false})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_dimension') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider v-if="selected.dimension.length"></v-divider>
                        <v-list-item
                            v-if="selected.dimension.length"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_dimension') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.dimension.length"
                            @click="openDimensionDialog({editMode: true, id: selected.dimension[0].id })"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_dimension') }}</v-list-item-title>
                        </v-list-item>
                         <v-list-item
                            v-if="selected.dimension.length"
                            @click="openDeleteSingleDialog({ target: 'dimension', id: selected.dimension[0].id })"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_dimension') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <!-- <v-data-table
                    dense
                    show-select
                    single-select
                    v-model="selected.dimension"
                    :loading="loading.data"
                    :headers="headers.dimension"
                    :items="dimensions">
                </v-data-table> -->
                <v-row>
                    <v-col>
                        <div v-if="loading.data" class="text-center">
                            <v-progress-linear
                                indeterminate>
                            </v-progress-linear>
                        </div>
                        <v-card-text>
                            <v-treeview
                                item-key="id"
                                style="cursor: pointer"
                                :active.sync="selected.dimension"
                                dense
                                transition
                                activatable
                                :items="dimensions"
                                return-object
                                >
                                <template v-slot:label="{ item }">
                                    <div :class="item.children.length > 0 ? 'font-weight-bold' : 'font-weight-medium' " >{{ item.name }}</div>
                                </template>
                                <template v-slot:append="{ item }">
                                    <div >{{ formatNumber(item.total, 2) }}</div>
                                </template>
                            </v-treeview>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <RetryDialog
            @submit="onRetryDialogSubmit"
            ref="retryDialog"/>
            <dimension-dialog
                v-if="dimensionDialogProps.display"
                :id="dimensionDialogProps.id"
                @close="closeDimensionDialog"
                @submit="createDataFetch">
            </dimension-dialog>
            <delete-single-dialog
                @close="closeDeleteSingleDialog"
                @submit="onDeleteDialogSubmit"
                ref="deleteSingleDialog">
            </delete-single-dialog>
    </div>
</template>

<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions } from 'vuex'
import DimensionDialog from '../../components/accounting/DimensionDialog.vue';
import DeleteSingleDialog from '@/components/common/DeleteSingleDialog.vue';
import { getChart } from '../../services/ledger/dimension';
import { formatNumber } from 'accounting';
export default {
    name: 'Dimensions',
    components: {DimensionDialog, RetryDialog, DeleteSingleDialog},
    props: {},
    data() {
        return {
            loading: {
                data: false
            },
            selected: {
                dimension: []
            },
            dimensions: [],
            headers: {
                dimension: [
                    { text: this.$t('code_'), value: 'code' },
                    { text: this.$t('dimension'), value: 'name' },
                    { text: this.$t('code'), value: 'number' },
                    { text: this.$t('dimension_type'), value: 'type' },
                    { text: this.$t('parent'), value: 'parent' }
                ]
            },
            options: {},
            search: null,
            dimensionDialogProps: {
                id: null,
                display: false
            }
        }
    },
    computed: {
        item() {
            return [
                {
                    name: 'Dimensions',
                    children: this.dimensions
                }
            ]
        }
    },
    methods: {
        ...mapActions('accounting/dimension', ["removeDimension"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        formatNumber,
        async fetchDimensions() {
            return await getChart();
        },
        async createDataFetch() {
            try {
                this.loading.data = true;
                let result =  await this.fetchDimensions();
                this.dimensions = result.data;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },

        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        openDimensionDialog({ editMode, id }) {
            editMode ? this.dimensionDialogProps.id = id : this.dimensionDialogProps.id = null;
            this.dimensionDialogProps.parent_id = this.id;
            this.dimensionDialogProps.display = true;
        },

        closeDimensionDialog() {
            this.dimensionDialogProps.display = false;
        },
        openDeleteSingleDialog(params) {
            this.$refs.deleteSingleDialog.open(params);
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'dimension') {
                this.removeDimension(params)
                    .then(() => {
                        this.$emit('removeDimensionSuccessfully');
                        this.setSnackBars({color: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.closeDeleteSingleDialog();
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }
        },
        closeDeleteSingleDialog() {
           this.$refs.deleteSingleDialog.close();
        },

    },
    created() {
        this.createDataFetch();
    },
    updated() {
        this.$on('removeDimensionSuccessfully', () => {
            this.createDataFetch();
        })
    }
}
</script>

<style>

</style>